import React from 'react';
import { formatStudentClass, formatStudentName, getLinkedStudent } from './enquiryStudentUtils';

const EnquiryStudentFields = ({ student, textClassName = 'xxs-text f-op m-weight' }) => {
  const linked = getLinkedStudent(student);

  if (!linked) {
    return (
      <div>
        <label>Student</label>
        <p className={`${textClassName} caps`}>Not linked</p>
      </div>
    );
  }

  return (
    <>
      <div>
        <label>Student Name</label>
        <p className={`${textClassName} caps`}>{formatStudentName(linked)}</p>
      </div>
      <div>
        <label>Class</label>
        <p className={`${textClassName} caps`}>{formatStudentClass(linked)}</p>
      </div>
      <div>
        <label>Gender</label>
        <p className={`${textClassName} caps`}>{linked.gender || '-'}</p>
      </div>
    </>
  );
};

export default EnquiryStudentFields;
